import {
  Menu,
  Search,
  Bell,
  Settings,
  ChevronRight,
  ChevronDown,
  LogOut,
  LayoutDashboard,
  BookOpen,
  Calendar,
  ClipboardCheck,
  FileText,
  BarChart2,
  MessageSquare,
  Megaphone,
  Library,
  CheckCircle2,
  Plus,
  Pencil,
  Trash2,
  PowerOff,
  type LucideProps,
} from 'lucide-react'

export function EditIcon(props: LucideProps) {
  return <Pencil {...props} />
}

export function PencilIcon(props: LucideProps) {
  return <Pencil {...props} />
}

export function MenuIcon(props: LucideProps) {
  return <Menu {...props} />
}

export function SearchIcon(props: LucideProps) {
  return <Search {...props} />
}

export function BellIcon(props: LucideProps) {
  return <Bell {...props} />
}

export function SettingsIcon(props: LucideProps) {
  return <Settings {...props} />
}

export function ChevronRightIcon(props: LucideProps) {
  return <ChevronRight {...props} />
}

export function ChevronDownIcon(props: LucideProps) {
  return <ChevronDown {...props} />
}

export function LogoutIcon(props: LucideProps) {
  return <LogOut {...props} />
}

export function DashboardIcon(props: LucideProps) {
  return <LayoutDashboard {...props} />
}

export function BookOpenIcon(props: LucideProps) {
  return <BookOpen {...props} />
}

export function CalendarIcon(props: LucideProps) {
  return <Calendar {...props} />
}

export function ClipboardCheckIcon(props: LucideProps) {
  return <ClipboardCheck {...props} />
}

export function DocumentIcon(props: LucideProps) {
  return <FileText {...props} />
}

export function ChartIcon(props: LucideProps) {
  return <BarChart2 {...props} />
}

export function MessageIcon(props: LucideProps) {
  return <MessageSquare {...props} />
}

export function MegaphoneIcon(props: LucideProps) {
  return <Megaphone {...props} />
}

export function LibraryIcon(props: LucideProps) {
  return <Library {...props} />
}

export function CheckCircleIcon(props: LucideProps) {
  return <CheckCircle2 {...props} />
}

export function PlusIcon(props: LucideProps) {
  return <Plus {...props} />
}

export function TrashIcon(props: LucideProps) {
  return <Trash2 {...props} />
}

export function DeactivateIcon(props: LucideProps) {
  return <PowerOff {...props} />
}
